import React from 'react';
import Services from '../services/Services';
import {
    usePropertyComplementaryData,
    usePropertyFetching,
    usePropertyRoomDetail,
} from '../../../contextsProperty/ContextProperties';
import LoadingTab from '../LoadingTab';

const RoomServices = () => {
    const { services, toggleRoomItemInCollection } = usePropertyRoomDetail();
    const { roomServiceCategoriesList, roomServiceTypesList } =
        usePropertyComplementaryData();
    const { isFetching } = usePropertyFetching();

    if (isFetching) {
        return <LoadingTab />;
    }
    return (
        <Services
            titlePage='what_services_does_your_room_have'
            titleServices='your_room_services'
            selectedServices={services}
            optionsCategories={roomServiceCategoriesList}
            options={roomServiceTypesList}
            onClickService={toggleRoomItemInCollection}
        />
    );
};

export default RoomServices;
